<template>
  <v-dialog
    v-model="show"
    :fullscreen="smAndDown"
    max-width="90%"
    scrollable
    persistent
  >
    <v-card height="90dvh" :loading="isLoadingSearch">
      <v-card-title class="px-4 px-sm-6">
        <TitleWidget small>Buscar pelo mapa</TitleWidget>

        <v-btn
          @click.prevent="$emit('close')"
          color="grey darken-3"
          absolute
          right
          icon
          top
        >
          <v-icon size="18">mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="px-0 px-sm-6 pb-0 pb-sm-6 grid-list">
        <div v-if="!smAndDown">
          <div v-if="fazendas.length" class="mx-n3 mt-3">
            <template v-for="(item, index) in parsedProperties">
              <div :key="`${item.fazenda.nome}-${index}-card`">
                <v-card
                  @click="onSelectFazenda(item)"
                  class="rounded-lg overflow-hidden pa-3"
                  flat
                  tile
                >
                  <div class="secondary--text">
                    {{ item.fazenda.nome }}
                  </div>
                </v-card>

                <v-divider
                  v-if="parsedProperties.length - 1 > index"
                  class="mx-3 my-1"
                  light
                />
              </div>
            </template>
          </div>

          <div v-else>
            <div class="secondary--text text-body-1 font-weight-regular">
              <template v-if="isLoadingSearch"> Carregando... </template>
              <template v-else>
                Nenhuma área encontrada

                <div class="text-body-2 mt-2">
                  Use o campo ao lado ou arraste o mapa para encontrar as áreas
                </div>
              </template>
            </div>
          </div>
        </div>

        <MapsSearch @onGetPositions="onGetPositions" :fazendas="fazendas" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import TitleWidget from "@/components/widgets/Title.vue";
import MapsSearch from "./MapsSearch.vue";
import { mapActions } from "vuex";

export default {
  components: { TitleWidget, MapsSearch },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoadingSearch: true,
      fazendas: [],
    };
  },
  computed: {
    parsedProperties() {
      const groupedById = this.fazendas.reduce((acc, item) => {
        const key = item.fazenda_id;

        if (!acc[key]) {
          acc[key] = [];
        }

        acc[key].push(item);

        return acc;
      }, {});

      const items = [];
      Object.entries(groupedById).map(([key, obj]) => {
        items.push(obj.shift());
      });

      return items;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    ...mapActions("properties", ["getFromLocation"]),
    onSelectFazenda(item) {
      let route = this.$router.resolve({
        path: "/portfolio/" + item.fazenda.id,
      });

      window.open(route.href);
    },
    async onGetPositions(positions) {
      this.isLoadingSearch = true;

      let fazendas = await this.getFromLocation(positions);

      this.fazendas = fazendas;

      this.isLoadingSearch = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.grid-list {
  display: grid;
  gap: 24px;
  grid-template-columns: 270px calc(100% - 294px);

  @media screen and (max-width: 959.9px) {
    grid-template-columns: 100%;
  }
}
</style>
